// Central social media links - update here to change everywhere
export const INSTAGRAM_URL = "https://www.instagram.com/base_iy2026";
export const FACEBOOK_URL = "https://www.facebook.com/share/18A1CKQG5H/";
export const FACEBOOK_MESSENGER_URL = "https://m.me/wood18home";
